import React from "react";
import { Button } from "aible";

import Select from "react-select";

import { LineInput } from "components/Inputs/LineInput";

import MarketTile from "components/Market/MarketTile/MarketTile";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class CreateJobModal extends React.Component {
  constructor(props) {
    super(props);
    const { isCreateJob } = this.props;

    this.state = {
      title: isCreateJob?.title || "",
      subTitle: isCreateJob?.subTitle || "",
      textBody: isCreateJob?.textBody || "",
      cHoursAgo: isCreateJob?.cHoursAgo || 0,
      contractType: isCreateJob?.contractType || "",
      contractLength: isCreateJob?.contractLength || "",
      budget: 120,
      maxBudget: 500,
      rateType: isCreateJob?.rateType || "Per Hour"
    };
  }

  componentDidUpdate(prevProps) {
    const { isCreateJob } = this.props;

    if (isCreateJob !== undefined && isCreateJob !== false && prevProps.isCreateJob === false && isCreateJob !== true) {
      this.setState({
        id: isCreateJob.id,
        nextId: isCreateJob.nextId,
        title: isCreateJob.title,
        subTitle: isCreateJob.subTitle,
        textBody: isCreateJob.textBody,
        cHoursAgo: isCreateJob.cHoursAgo,
        contractType: isCreateJob.contractType,
        contractLength: isCreateJob.contractLength,
        rateType: isCreateJob.rateType
      });
    } else if (isCreateJob === true && prevProps.isCreateJob === false) {
      this.setState({
        id: undefined,
        nextId: "",
        title: "",
        subTitle: "",
        textBody: "",
        cHoursAgo: "",
        contractType: "",
        contractLength: "",
        budget: 120,
        rateType: "Per Hour"
      });
    }
  }

  render() {
    const { isCreateJob, updateIsCreateJob, createJob, noModal, handleBackModels } = this.props;

    const nextId = this.props?.id;
    const { id, title, textBody, contractType, contractLength, budget, maxBudget } = this.state;

    const contractTypes = ["Data Exploration", "Data Exploration / AI Creation", "AI Creation / Deployment"];
    const contractLengths = ["8 Hours", "1 Month", "2 Month", "3 Month", "6 Month", "Part Time"];

    const renderNoModal = () => {
      return (
        <div className={styles.createJobPanel}>
          <div className={styles.modalBody} style={{ flexFlow: "column" }}>
            <div className={styles.modalRight}>
              <div className={styles.jobInput} style={{ marginBottom: "10px" }}>
                <div className={styles.jobLeft}>{"Job Title: "}</div>
                <div className={styles.jobRight}>
                  <LineInput isMediumBox onChange={(val) => this.setState({ title: val })} value={title} />
                </div>
              </div>
              <div className={styles.jobInput}>
                <div className={styles.jobLeft}>{"Job Description: "}</div>
                <div className={styles.jobRight}>
                  <textarea
                    className={styles.jobDescription}
                    style={{ width: "100%", height: "100px" }}
                    onChange={(e) => this.setState({ textBody: e.target.value })}
                    value={textBody}
                  />
                </div>
              </div>
              <div className={styles.jobInput} style={{ display: "flex" }}>
                <div>
                  <div className={styles.jobLeft}>{"Hourly Fee:"}</div>
                  <div className={styles.rightFlex}>
                    <span className={styles.currencyBox}>{"$"}</span>
                    <LineInput
                      isMediumBox
                      onChange={(val) => this.setState({ budget: val })}
                      value={budget}
                      style={{ marginRight: "-10px" }}
                    />
                  </div>
                </div>
                <div>
                  <div className={styles.jobLeft}>{"Max Training Budget:"}</div>
                  <div className={styles.rightFlex}>
                    <span className={styles.currencyBox}>{"$"}</span>
                    <LineInput
                      isMediumBox
                      onChange={(val) => this.setState({ maxBudget: val })}
                      value={maxBudget}
                      style={{ marginRight: "-10px" }}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.jobInput}>
                <div className={styles.jobLeft}>{"Job Type: "}</div>
                <div className={styles.jobRight}>
                  <Select
                    options={contractTypes.map((t) => ({
                      value: t,
                      label: t
                    }))}
                    onChange={(val) => this.setState({ contractType: val.value })}
                    value={
                      contractTypes.find((t) => t === contractType)
                        ? {
                            value: contractTypes.find((t) => t === contractType),
                            label: contractTypes.find((t) => t === contractType)
                          }
                        : undefined
                    }
                    menuPlacement="top"
                  />
                </div>
              </div>
              <div className={styles.jobInput}>
                <div className={styles.jobLeft}>{"Estimated Training Length: "}</div>
                <div className={styles.jobRight}>
                  <Select
                    options={contractLengths.map((t) => ({
                      value: t,
                      label: t
                    }))}
                    onChange={(val) => this.setState({ contractLength: val.value })}
                    value={
                      contractLengths.find((t) => t === contractLength)
                        ? {
                            value: contractLengths.find((t) => t === contractLength),
                            label: contractLengths.find((t) => t === contractLength)
                          }
                        : undefined
                    }
                    menuPlacement="top"
                  />
                </div>
              </div>
            </div>
            <div className={styles.modalLeft} style={{ width: "100%", height: "100%" }}>
              <div>{"Job Posting Preview"}</div>
              <MarketTile data={this.state} nextId={nextId} type={"job postings"} isPreview />
            </div>
          </div>
          <div className={styles.modalFooter} style={{ marginTop: "5px" }}>
            <Button
              type="primary"
              onClick={() => {
                createJob({ ...this.state });
                handleBackModels();
              }}
              style={{ width: "100%" }}
            >
              {id !== undefined ? "Update" : "Post this Job"}
            </Button>
          </div>
        </div>
      );
    };
    return noModal ? (
      renderNoModal()
    ) : (
      <div id={"jobCreate"}>
        <Dialog
          open={isCreateJob !== false && !isCreateJob?.suppressModal}
          onOpenChange={() => updateIsCreateJob(false)}
        >
          <DialogContent size="xl">
            <DialogHeader>
              <DialogTitle>{id !== undefined ? "Edit Job" : "Automatically Post a Job to the Marketplace"}</DialogTitle>
            </DialogHeader>

            <div className={styles.modalBody}>
              <div className={styles.modalLeft}>
                <div>{"Job Posting Preview"}</div>
                <MarketTile data={this.state} type={"job postings"} isPreview />
              </div>
              <div className={styles.modalRight}>
                <div className={styles.jobInput}>
                  <div className={styles.jobLeft}>{"Job Title: "}</div>
                  <div className={styles.jobRight}>
                    <LineInput isMediumBox onChange={(val) => this.setState({ title: val })} value={title} />
                  </div>
                </div>
                <div className={styles.jobInput}>
                  <div className={styles.jobLeft}>{"Job Description: "}</div>
                  <div className={styles.jobRight}>
                    <textarea
                      className={styles.jobDescription}
                      onChange={(e) => this.setState({ textBody: e.target.value })}
                      value={textBody}
                    />
                  </div>
                </div>
                <div className={styles.jobInput} style={{ display: "flex" }}>
                  <div>
                    <div className={styles.jobLeft}>{"Hourly Fee:"}</div>
                    <div className={styles.rightFlex}>
                      <span className={styles.currencyBox}>{"$"}</span>
                      <LineInput
                        isMediumBox
                        onChange={(val) => this.setState({ budget: val })}
                        value={budget}
                        style={{ marginRight: "-10px" }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className={styles.jobLeft}>{"Max Training Budget:"}</div>
                    <div className={styles.rightFlex}>
                      <span className={styles.currencyBox}>{"$"}</span>
                      <LineInput
                        isMediumBox
                        onChange={(val) => this.setState({ maxBudget: val })}
                        value={maxBudget}
                        style={{ marginRight: "-10px" }}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.jobInput}>
                  <div className={styles.jobLeft}>{"Job Type: "}</div>
                  <div className={styles.jobRight}>
                    <Select
                      options={contractTypes.map((t) => ({
                        value: t,
                        label: t
                      }))}
                      onChange={(val) => this.setState({ contractType: val.value })}
                      value={
                        contractTypes.find((t) => t === contractType)
                          ? {
                              value: contractTypes.find((t) => t === contractType),
                              label: contractTypes.find((t) => t === contractType)
                            }
                          : undefined
                      }
                      menuPlacement="top"
                    />
                  </div>
                </div>
                <div className={styles.jobInput}>
                  <div className={styles.jobLeft}>{"Estimated Training Length: "}</div>
                  <div className={styles.jobRight}>
                    <Select
                      options={contractLengths.map((t) => ({
                        value: t,
                        label: t
                      }))}
                      onChange={(val) => this.setState({ contractLength: val.value })}
                      value={
                        contractLengths.find((t) => t === contractLength)
                          ? {
                              value: contractLengths.find((t) => t === contractLength),
                              label: contractLengths.find((t) => t === contractLength)
                            }
                          : undefined
                      }
                      menuPlacement="top"
                    />
                  </div>
                </div>
              </div>
            </div>

            <DialogFooter>
              <Button type="secondary" onClick={() => updateIsCreateJob(false)} style={{ marginRight: "auto" }}>
                {"Close"}
              </Button>
              <Button type="primary" onClick={() => createJob({ ...this.state })}>
                {id !== undefined ? "Update" : "Create"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
